import ReactRailsUJS from 'react_ujs'

import { viteConstructorRequireContext } from '../helpers/ViteHelper'
import baseFrontModules from '../helpers/entrypoint_modules/baseFront'

const roiContexts = import.meta.globEager([
        '~/independent_pages/tools/roi_calculator/**/*.{js,jsx,ts,tsx}',
    ]
)
const contexts = Object.assign(roiContexts, baseFrontModules)

ReactRailsUJS.getConstructor = viteConstructorRequireContext(contexts)